import { useContext } from "react";

import { CreateEntityResponse } from "../../../common/api/common/CreateEntityResponse";
import { AppConfigContext } from "../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../core/data-access/useAuthorizedFetch";
import { CreateSystemRequest } from "./CreateSystemRequest";
import { EditSystemRequest } from "./EditSystemRequest";
import { GetSystemsByIntegratorRequest } from "./GetSystemsByIntegratorRequest";
import { GetSystemsByIntegratorResponse } from "./GetSystemsByIntegratorResponse";

export const useAdminSystemApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const { httpGet, httpPost, httpPut } = useAuthorizedFetch();
    const baseUrl = `${appConfigContext.ordersConfig.apiUrl}/systems`;

    const getSystemsByIntegrator = async (
        request: GetSystemsByIntegratorRequest
    ): Promise<GetSystemsByIntegratorResponse> => {
        return httpGet<GetSystemsByIntegratorResponse>(`${baseUrl}/list-by-integrator`, request);
    };

    const createSystem = async (request: CreateSystemRequest): Promise<CreateEntityResponse> => {
        return httpPost<CreateEntityResponse>(`${baseUrl}/create`, request);
    };

    const updateSystem = async (request: EditSystemRequest): Promise<void> => {
        return httpPut(`${baseUrl}/update`, request);
    };

    return {
        getSystemsByIntegrator,
        createSystem,
        updateSystem
    };
};
